/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A credential a server offers that the profile's turns can use.
 */
export type ExecutionProfileOption = {
  /**
   * The auth client.
   */
  authClientId: string;
  /**
   * The auth client's type.
   */
  clientType: string;
  /**
   * The auth client's name.
   */
  name: string;
};

/** @internal */
export const ExecutionProfileOption$inboundSchema: z.ZodMiniType<
  ExecutionProfileOption,
  unknown
> = z.pipe(
  z.object({
    auth_client_id: z.string(),
    client_type: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "auth_client_id": "authClientId",
      "client_type": "clientType",
    });
  }),
);

export function executionProfileOptionFromJSON(
  jsonString: string,
): SafeParseResult<ExecutionProfileOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExecutionProfileOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExecutionProfileOption' from JSON`,
  );
}
